import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG'

const RedirectionLoader = (props) => {
    const { sessionId } = props
    return (
        <div className='fixed left-0 right-0 bottom-0 top-0 w-full h-full backdrop-blur-sm bg-black/75 z-[100] flex items-center justify-center gap-3 flex-col'>
            <LoaderSVG />
            <span className='text-lg font-medium tracking-wide text-white'>{sessionId ? 'Please wait until payment confirmed...' : ' Redirecting to stripe...'}</span>
        </div>
    )
}

export default RedirectionLoader
